import React, {Component} from 'react';
import {Link} from 'react-router-dom'
import AppBar from 'material-ui/AppBar';
import MenuItem from 'material-ui/MenuItem';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import {Toolbar, ToolbarTitle, ToolbarGroup} from 'material-ui/Toolbar';
import Authorized from "../auth/Authorized";

class Header extends Component {

    state = {
        menuOpen: false
    };

    handleToggle= () => this.setState({menuOpen: !this.state.menuOpen});

    handleClose = () => this.setState({menuOpen: false});

    render() {
        return (
        <div>
            <AppBar title="Loomis" onLeftIconButtonClick={this.handleToggle} />

            <Drawer open={this.state.menuOpen} docked={false} onRequestChange={(menuOpen) => this.setState({menuOpen})}>
                <Toolbar>
                    <ToolbarGroup>
                        <ToolbarTitle text="SAFEPOINT" />
                        <IconButton
                            iconClassName="material-icons"
                            onTouchTap={this.handleClose}
                        >
                            close
                        </IconButton>
                    </ToolbarGroup>
                </Toolbar>
                <MenuItem
                    containerElement={<Link to="/start" />}
                    onTouchTap={this.handleClose}
                    primaryText="Start" />
                <Authorized userrole="ROLE_CUSTOMER">
                    <MenuItem
                        containerElement={<Link to="/customers" />}
                        onTouchTap={this.handleClose}
                        primaryText="Customers" />
                </Authorized>
                <Authorized userrole="ROLE_SERVER">
                    <MenuItem
                    containerElement={<Link to="/servers" />}
                    onTouchTap={this.handleClose}
                    primaryText="Servers" />
                </Authorized>
                <MenuItem
                    containerElement={<Link to="/countries" />}
                    onTouchTap={this.handleClose}
                    primaryText="Countries" />
                <Authorized userrole="ROLE_USER">
                    <MenuItem
                        containerElement={<Link to="/users" />}
                        onTouchTap={this.handleClose}
                        primaryText="Users" />
                </Authorized>
                <MenuItem
                    onTouchTap={this.props.logout}
                    primaryText="Logout" />
            </Drawer>

        </div>
        );
    };
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header/Header.js